<template>
    <div>
        <b-form-group
            label="Expression"
            label-for="expression"
            :label-cols="3"
            :horizontal="false">
            <CodeEditor v-model="constraints.custom_data.external.expression" :libs="libs" :vars="vars">
                <HowItWorksPopup >
                    Expression should <code>resolve</code> promise. Resolved data will be used as data source for select field.
                    <p>Ex:</p>
                    <pre class="example">
get('https://restcountries.com/v3.1/name/' + context.keyword)
.then(resp => {
    let data = resp.data.map(d => {
        return d.name.common
    })
    
    resolve(data);
})
                    </pre>
                </HowItWorksPopup>
            </CodeEditor>
        </b-form-group>
    </div>
</template>

<script>
import CodeEditor from '@/components/form/Editor/Code'
import HowItWorksPopup from '../../../elements/HowItWorksPopup'

export default {
    components: {
        CodeEditor,
        HowItWorksPopup
    },
    props: {
        value: {
            type: Object
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    watch: {
        errors(val) {
            this.$emit('error', val[0])
        }
    },
    computed: {
        constraints() {
            let base = this.value

            base.custom_data = base.custom_data || {
                external: {
                    expression: ''
                }
            }

            base.custom_data.external = base.custom_data.external || {}

            return base;
        },

        libs() {
            return [
                {
                    name: "protokol/http",
                    varName: "{ get }",
                    docs: this.docsUrl + "/docs#libs-http"
                },
                {
                    name: "protokol/context",
                    varName: "context",
                    docs: this.docsUrl + "/docs#libs-context"
                }
            ]
        },

        vars() {
            return [
                {
                    name: "pagination",
                    usage: JSON.stringify({
                        currentPage: 1
                    })
                },
                {
                    name: "keyword",
                    usage: "Current keyword in search"
                }
            ]
        }
    },
    methods: {}
    
}
</script>